import folderSvg from './folder-svg';

const ARROW_UP = `
    <div class="folder-icon-up-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#ffffff" aria-hidden="true">
        <path fill="#ffffff" d="M256.2,16,56,215.993v38.632H176v144H336v-144H456V216ZM304,222.625v144H208v-144H94.639L256.174,61.254l161.21,161.371Z" />
        <rect width="400" height="32" x="56" y="462.625" fill="#ffffff" />
      </svg>
    </div>`;

export default function folderUpSvg(options = {}) {
  return folderSvg(options).replace(/<\/div>\s*$/, `${ARROW_UP}</div>`);
}
